import gql from 'graphql-tag';

export default gql`
  mutation disableUser($userId: UUID!) {
    disableUser(userId: $userId)
  }
`;
